module.exports = __webpack_public_path__ + "static/media/Whatsapp_Guide_Android_Chin.498d409d.docx";